module.exports = __webpack_public_path__ + "static/media/dualgunner-logo.732728cd.png";